<script>
import ModalWrapperChoice from "@/components/modals/ModalWrapperChoice";

export default {
  name: "CloudInvalidDataModal",
  components: {
    ModalWrapperChoice,
  },
  props: {
    isSaving: {
      type: Boolean,
      required: true,
    }
  },
  computed: {
    conflict() {
      return this.$viewModel.modal.cloudConflict;
    },
    overwriteText() {
      return this.isSaving
        ? "Перезаписать Облачное Сохранение"
        : "Загрузить сохранение с Облака";
    }
  },
  methods: {
    ignore() {
      EventHub.dispatch(GAME_EVENT.CLOSE_MODAL);
    },
    overwrite() {
      this.conflict.onAccept?.();
      EventHub.dispatch(GAME_EVENT.CLOSE_MODAL);
    }
  },
};
</script>

<template>
  <ModalWrapperChoice
    class="c-modal-options__large"
    :cancel-class="'c-modal-message__okay-btn'"
    :confirm-class="'c-modal-message__okay-btn c-modal__confirm-btn'"
    :cancel-fn="overwrite"
    @confirm="ignore()"
  >
    <template #header>
      Не получается сравнить с Облачным Сохранением
    </template>
    При попытке сравнить ваше сохранение, у игры не получилось корректно обработать данные в вашем
    Облачном Сохранении. Скорее всего это связано с тем, что Облачное Сохранение сильно устарело и использует
    формат данных с гораздо более старой версии игры.
    <br>
    <br>
    <span v-if="isSaving">
      Скорее всего перезаписать ваше Облачное Сохранение безопасно. Вы можете кликнуть "Загрузить с Облака" и принудить
      сохранение к загрузке если вы хотите попробовать конвертировать его в формат который сможете использовать.
    </span>
    <span v-else>
      Вы можете загрузить сохранение с Облака если хотите. Игра попытается загрузить ваши
      Облачные данные конвертацией формата, однако это может не сработать и в худшем случае может заставить вас
      сбросить этот слот сохранения для того чтобы игра вновь заработала.
    </span>
    <br>
    Примечание: Эта надпись будет появляться независимо от ваших настроек, потому что эта проблема будет продолжать
    мешать 10-минутному автосохранению до тех пор пока она не решена.
    <template #cancel-text>
      {{ overwriteText }}
    </template>
    <template #confirm-text>
      Не перезаписывать
    </template>
  </ModalWrapperChoice>
</template>
